import * as React from "react";
const SvgTariffStartCircle = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("rect", { width: 40, height: 40, rx: 20, fill: "white" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M27.0343 12.8172C26.8329 12.7372 26.6113 12.7163 26.3974 12.7571C26.1836 12.7979 25.9872 12.8985 25.8331 13.0462C25.1619 13.6863 24.2533 14.0457 23.3061 14.0457C22.359 14.0457 21.4504 13.6863 20.7791 13.0462C19.6946 12.0103 18.2255 11.4286 16.6939 11.4286C15.1623 11.4286 13.6932 12.0103 12.6086 13.0462C12.4019 13.2442 12.2858 13.5126 12.2857 13.7926V27.5158C12.2857 27.7958 12.4018 28.0643 12.6085 28.2623C12.8152 28.4602 13.0955 28.5714 13.3878 28.5714C13.68 28.5714 13.9603 28.4602 14.167 28.2623C14.3737 28.0643 14.4898 27.7958 14.4898 27.5158V22.7095C15.1779 22.1953 16.0383 21.9394 16.9095 21.9899C17.7807 22.0404 18.6026 22.3939 19.2209 22.984C20.3054 24.0199 21.7745 24.6016 23.3061 24.6016C24.8377 24.6016 26.3068 24.0199 27.3914 22.984C27.5981 22.786 27.7142 22.5176 27.7143 22.2376V13.7926C27.7143 13.5838 27.6498 13.3797 27.5287 13.2061C27.4077 13.0325 27.2357 12.8971 27.0343 12.8172Z",
      fill: "#00BFFF"
    }
  )
);
export default SvgTariffStartCircle;
